const validation = require('./validation.js');
require('slick-carousel');

$.fn.hasAttr = function(name) {
	return this.attr(name) !== undefined;
};

$.fn.iframeClick = function(callback = null) {
	var $this = $(this);
	var isOverIframe = false;
	var windowLostBlur = function () {
		if (isOverIframe === true) {
			$this.trigger('iframeclick');
			if (typeof callback === 'function') { callback(); }
			isOverIframe = false;
		}
	};
	$(window).focus();
	$this.on('mouseenter', function () { isOverIframe = true; });
	$this.on('mouseleave', function () { isOverIframe = false; });
	$(window).blur(function () { windowLostBlur(); });
}

$('img[alt=""]').each(function(){
	var $img = $(this);
	var filename = $img.attr('src');
	var clean = filename.substring((filename.lastIndexOf('/'))+1, filename.lastIndexOf('.')).replace(/([\-\_\+\.]|(min)$)/g, ' ');
	$img.attr('alt', clean);
});

$('a.scroll').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
		var target = $(this.hash);
		var offset = $(this).hasAttr('data-offset') ? $(this).attr('data-offset') : 0;
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		 if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top + parseInt(offset, 10)
			}, 1000);
			return false;
		}
	}
});

$('input[name="form"]').each(function(index, el) {
	$(el).val($(this).closest('section').attr('id'));
});

/* POPUPS */
$('[data-popup-open]').on('click', function(event) {
	event.preventDefault();
	var $popup = $('[data-popup="'+$(this).attr('data-popup-open')+'"]');
	$popup.removeClass('hidden').fadeTo(400, 1).attr('data-offset', $(document).scrollTop());
	$('body').addClass('popup-shown');
	$popup.trigger('popup_opened');
});

$('[data-popup-bg], [data-popup-close], [data-popup-close]').on('click', function(event) {
	event.preventDefault();
	var $popup = $(this).closest('[data-popup]');
	$popup.fadeTo(400, 0).promise().done(function(){
		$(this).addClass('hidden');
	});
	$('body').removeClass('popup-shown');
	if ($popup.hasAttr('data-offset') && window.innerWidth < 768) {
		$(document).scrollTop($popup.attr('data-offset'));
	}
	$popup.trigger('popup_closed');
});

/* Gtag */
$('.form-pdf-main').submit(function(){
  gtag('event', 'pdf', {
  'event_category': 'Conversion',
  'event_label': 'Main',
  });
});

$('.form-pdf-success').submit(function(){
  gtag('event', 'pdf', {
  'event_category': 'Conversion',
  'event_label': 'Success',
  });
});

$('.points-install .title-point').click(function() {
	var text = $(this).parent().find('.text-point');
	var point = $(this).parent();
	//$('.points-install .point .text-point').slideUp('fast');
     if (text.hasClass('active')) {
        $(this).find('.arrow').removeClass('active');
        text.removeClass('active');
        point.removeClass('active');
    } else {
    	$('.points-install .point .text-point').removeClass('active');
    	$('.points-install .point .title-point .arrow').removeClass('active');
    	$('.points-install .point').removeClass('active');
        text.addClass('active');
        point.addClass('active');
        //text.slideDown('fast');
        $(this).find('.arrow').addClass('active');
    }
     return false;
});

$('.top-content .title-point').click(function() {
	var text = $(this).parent().parent().find('.text-point');
	var arrow = $(this).find('.arrow-point');
	var point = $(this).parent().parent();
	//$('.points-advantages .point .text-point').slideUp('fast');
   if (text.hasClass('active')) {
        arrow.removeClass('active');
        text.removeClass('active');
        point.removeClass('active');
        //text.slideUp('fast');;
   } else {
   	$('.points-advantages .point .text-point').removeClass('active');
   	$('.points-advantages .point .title-point .arrow-point').removeClass('active');
        text.addClass('active');
        point.addClass('active');
        //text.slideDown('fast');
        arrow.addClass('active');
   }
   return false;
});

$('.info-btn').click(function() {
		var text_popup = $(this).parent().parent().find('.text-popup');
        text_popup.addClass('active');

});

$('.close-popup').click(function() {
		var text_popup = $(this).parent();
        text_popup.removeClass('active');

});

$('.point.numb1').after($(".how-system-works .warning-1"));
$('.point.numb1').after($(".how-system-works .recuperation-text"));
$('.point.numb3').after($(".how-system-works .warning-2"));
$('.point.numb5').after($(".how-system-works .warning-3"));

$("#toggle-menu").click(function () {
   var btn = $(this);
   if (btn.hasClass('active')) {
      $('body').removeClass('no-scroll');
      $('.topbar .topbar_items').css('right', '');
      btn.removeClass('active');
  	} 	else {
      $('body').addClass('no-scroll');
     $('.topbar .topbar_items').css('right', '0');
      btn.addClass('active');
  	}
});

$('select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
        //console.log($this.val());
    });

    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
    });

});

/* Slick */

$('.slider-points-why').slick({
	infinite: true,
	//autoplay: true,
   dots: true,
   dotsClass: 'custom_paging',
    customPaging: function (slider, i) {
        console.log(slider);
        return  '<span class="cur-slide">0' + (i + 1) + '</span>' + '&nbsp/' + '<span class="count-slide">0' + slider.slideCount + '</span>';
    },
	prevArrow:"<button type='button' class='slick-prev pull-left'><span></span></button>",
   nextArrow:"<button type='button' class='slick-next pull-right'><span></span></button>"
});
